import { useEffect } from "react";

const DEFAULTS = {
    title: "Matériel Dentaire au Maroc | Équipements & Consommables | DENTIPRIME",
    description:
        "Fournisseur de matériel dentaire au Maroc : équipements, consommables et fournitures dentaires professionnels pour cabinets et laboratoires. Livraison nationale 24h-72h.",
    url: "https://dentiprime.ma/",
};

const setMeta = (selector, attr, value) => {
    const el = document.head.querySelector(selector);
    if (el) el.setAttribute(attr, value);
};

const apply = ({ title, description, url }) => {
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
};

const SEO = ({ title, description, url }) => {
    useEffect(() => {
        apply({
            title: title || DEFAULTS.title,
            description: description || DEFAULTS.description,
            url: url || DEFAULTS.url,
        });
        return () => apply(DEFAULTS);
    }, [title, description, url]);
    return null;
};

export default SEO;
